<div>
    <a (click)="deleteAccess()">تسجيل الخروج</a>
</div>